export const kAllowedTestValues = [
  'heartRate',
  'oxygen',
  'bloodPressure',
  'bodyScore',
  'hydration',
  'stress',
  'energy',
  'hrv',
  'temperature',
  'vitalCharge',
  'vaScore',
  'csi',
  'pwv',
  'pat',
  'pp',
  'ri',
  'va',
  'bmi',
  'fat',
  'bmr',
  'metabolic',
  'muscleMass',
  'biva',
  'morningReserve',
  'brainHeartLink',
  'orthostaticBrainPerfusion',
  'bodyBalance',
  'trainingReadiness',
  'stressShield',
  'nighttimeRecovery',
  'vascularYouth',
  'orthostaticRecoveryIndex',
] as const;

export const kCardColors = [
  { name: 'Blue', hex: '#4B9FFF' },
  { name: 'Lime', hex: '#C4E55E' },
  { name: 'Indigo', hex: '#8D80FF' },
  { name: 'Mint', hex: '#62DDB3' },
  { name: 'Violet', hex: '#B171F4' },
  { name: 'Teal', hex: '#73E4E4' },
  { name: 'Purple', hex: '#DC6CE0' },
  { name: 'Pink', hex: '#F985C9' },
  { name: 'Orange', hex: '#FFBC5E' },
  { name: 'Red', hex: '#EE696F' },
  { name: 'Orange 2', hex: '#FF9736' },
  { name: 'Green', hex: '#5AB881' },
  { name: 'Yellow', hex: '#FFE37E' },
] as const;

export const kIconAssetByName: Record<string, string> = {
  'heart.svg': '/icons/heart.svg',
  'right_now.svg': '/icons/right_now.svg',
  'stress.svg': '/icons/stress.svg',
  'battery.svg': '/icons/battery.svg',
  'battery_low.svg': '/icons/battery_low.svg',
  'battery_medium.svg': '/icons/battery_medium.svg',
  'battery_high.svg': '/icons/battery_high.svg',
  'water.svg': '/icons/water.svg',
  'workout_test.svg': '/icons/workout_test.svg',
  'what_i_should.svg': '/icons/what_i_should.svg',
  'track_workout.svg': '/icons/track_workout.svg',
  'trending.svg': '/icons/trending.svg',
  'Sleep.svg': '/icons/Sleep.svg',
  'arteries.svg': '/icons/arteries.svg',
  'muscule.svg': '/icons/muscule.svg',
  'nervous_system.svg': '/icons/nervous_system.svg',
  'human.svg': '/icons/human_icon.svg',
};

export const kAvailableIconNames = Object.keys(kIconAssetByName);

export const kTestConfigurationStatuses = ['active', 'inactive', 'hidden', 'dep'] as const;
